// Header events (analytics sheet → "Header" section).
import {logAnalyticsEvent} from './analytics';
import type {ContactMethodClickParams, UpdateLanguageParams} from './events';
import {AnalyticsEntryPoint} from './events';
import type {TrackedItem} from './shared';

const ENTRY_POINT = AnalyticsEntryPoint.Header;

export function trackHeaderTabClick(tabName: string, tabId?: string) {
  logAnalyticsEvent('header_tab_click', {
    entry_point: ENTRY_POINT,
    tab_name: tabName,
    tab_id: tabId,
  });
}

export function trackHeaderViewItemClick(item: TrackedItem) {
  logAnalyticsEvent('view_item_click', {
    entry_point: ENTRY_POINT,
    item_id: item.id,
    item_name: item.name,
  });
}

export function trackHeaderViewAllClick(item?: TrackedItem) {
  logAnalyticsEvent('view_all_click', {
    entry_point: ENTRY_POINT,
    item_id: item?.id,
    item_name: item?.name,
  });
}

export function trackLanguageSwitch(
  selected: UpdateLanguageParams['selected_language'],
  previous: UpdateLanguageParams['previously_selected_language'],
) {
  logAnalyticsEvent('update_language', {
    entry_point: ENTRY_POINT,
    selected_language: selected,
    previously_selected_language: previous,
  });
}

export function trackHeaderContactMethodClick(method: ContactMethodClickParams['item_type']) {
  logAnalyticsEvent('contact_method_click', {
    entry_point: ENTRY_POINT,
    item_type: method,
  });
}

export function trackHeaderRegisterInterestClick() {
  logAnalyticsEvent('register_interest_click', {entry_point: ENTRY_POINT});
}
